import { render, staticRenderFns } from "./Reports.page.vue?vue&type=template&id=2058f038&"
import script from "./Reports.page.vue?vue&type=script&lang=js&"
export * from "./Reports.page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports